<template>
  <div id="page-user-edit">
    <vs-alert
      color="danger"
      title="Client Not Found"
      :active.sync="client_not_found"
    >
      <span>Client record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span
        ><router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All Clients</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="client_data" class="pb-10">
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="tab-text">
          <div id="user-edit-tab-info">
            <div class="vx-row mt-10">
              <div class="vx-col w-full md:w-1/2">
                <div class="flex items-end">
                  <feather-icon
                    icon="UserIcon"
                    class="mr-2"
                    svgClasses="w-5 h-5"
                  />
                  <span class="leading-none font-medium"
                    >Personal Information</span
                  >
                </div>
              </div>
            </div>

            <div class="vx-row mt-0">
              <div class="vx-col w-full md:w-1/2">
                <div>
                  <vs-input
                    class="w-full mt-4"
                    label="First Name"
                    v-model="client_data.first_name"
                    v-validate="'required|alpha_spaces'"
                    name="first name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('first name')"
                    >{{ errors.first("first name") }}</span
                  >

                  <vs-input
                    class="w-full mt-4"
                    label="Last Name"
                    v-model="client_data.last_name"
                    v-validate="'required|alpha_spaces'"
                    name="last name"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('last name')"
                    >{{ errors.first("last name") }}</span
                  >
                </div>
              </div>

              <div class="vx-col w-full md:w-1/2">
                <vs-input
                  class="w-full mt-4"
                  label="Phone number"
                  v-model="client_data.phone_number"
                  v-validate="{ regex: '^\\+?([0-9]+)$' }"
                  name="phone number"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('phone number')"
                  >{{ errors.first("phone number") }}</span
                >

                <vs-input
                  class="w-full mt-4"
                  label="CIN"
                  v-model="client_data.cin"
                  name="cin"
                />
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                  <vs-button
                    id="button-with-loading"
                    class="ml-auto mt-2"
                    @click.prevent="save_changes"
                    :disabled="!validateForm || sending"
                    >Save Changes</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr,
  },
  data() {
    return {
      sending: false,
      client_data: {
        first_name: null,
        last_name: null,
        phone_number: null,
        cin: null,
      },
      client_not_found: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    capitalize_snake(str) {
      return (str.slice(0, 1).toUpperCase() + str.slice(1, str.length))
        .split("_")
        .join(" ");
    },
    save_changes() {
      this.sending = true;
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#button-with-loading",
        scale: 0.45,
      });
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.client_data.cin === null || this.client_data.cin === "") {
            this.client_data.cin = "-";
          }
          this.$store
            .dispatch("ADD_CLIENT", this.client_data)
            .then(() => {
              this.client_data = {
                first_name: null,
                last_name: null,
                phone_number: null,
                cin: null,
              };
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");

              this.$vs.notify({
                title: "Success",
                text: "Client ajouté avec succès",
                color: "success",
                position: "top-center",
              });
              this.sending = false;
            })
            .catch((error) => {
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
              this.sending = false;

              this.$vs.notify({
                title: "Erreur",
                text: `${error}`,
                color: "danger",
                position: "top-center",
              });
            });
        } else {
          return;
        }
      });
    },
  },
};
</script>
